import { ShieldOff } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@mehir/web-ui/button';
import { Card, CardContent } from '@mehir/web-ui/card';

export const Forbidden = () => (
  <div className="container mx-auto p-6">
    <Card>
      <CardContent className="flex flex-col items-center gap-4 py-16 text-center">
        <ShieldOff className="h-12 w-12 text-muted-foreground" />
        <div>
          <h1 className="text-xl font-semibold">Bu sayfaya erişim yetkiniz yok</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Erişim gerekiyorsa sistem yöneticinizden rolünüze ilgili izni eklemesini isteyin.
          </p>
        </div>
        <Link to="/">
          <Button variant="outline">Ana sayfaya dön</Button>
        </Link>
      </CardContent>
    </Card>
  </div>
);
